import { computed, inject } from '@angular/core';
import { patchState, signalStore, withComputed, withMethods, withState } from '@ngrx/signals';
import { firstValueFrom } from 'rxjs';
import { ConfigurationService } from 'src/app/services/api/configuration/configuration.service';
import { CONFIGURATION_UTILITIES } from 'src/app/shared/utility/configuration.utility';
import { OBJECT_UTILITIES } from 'src/app/shared/utility/object.utility';
import { ToastService } from 'vis-ods-angular';
import { withLoadingState } from '../loading-state/with-loading-state';
import { ConfigurationState, CountrySpecificSettings } from '../types/configuration.type';

export const ConfigurationStore = signalStore(
	{ providedIn: 'root' },
	withState<ConfigurationState>({
		settings: undefined,
	}),
	withComputed((state) => ({
		isBlockedFromOrdering: computed(() => state.settings()?.block_submit_order ?? false),
	})),
	withLoadingState({ settings: 'init' }),
	withMethods((state) => {
		const configurationService = inject(ConfigurationService);
		const toastService = inject(ToastService);
		return {
			fetchCountrySpecificSettings: async () => {
				state.loading('settings');
				const rawSettings = await firstValueFrom(
					configurationService.fetchCountrySpecificSettings(),
				);
				const settings = rawSettings.reduce<CountrySpecificSettings>(
					(prev, curr) =>
						OBJECT_UTILITIES.setValueAndReturn(
							prev,
							curr.name,
							CONFIGURATION_UTILITIES.getValueFromRawCountrySpecificSetting(curr),
						),
					{} as CountrySpecificSettings,
				);
				patchState(state, { settings });
				state.loaded('settings');

				toastService.setToastContainerConfig({
					stackToasts: settings.stack_toasts,
					maxStackedToastsDisplayed: settings.stack_toasts_display_max,
					desktopOrientation: {
						vertical: settings.desktop_orientation_vertical,
						horizontal: settings.desktop_orientation_horizontal,
					},
					mobileOrientation: {
						vertical: settings.mobile_orientation_vertical,
						horizontal: settings.mobile_orientation_horizontal,
					},
				});
			},
		};
	}),
);
